import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PasskeyOtpValidatePayload {
  oneTimePassCode: string;
  username: string;
  passkeyToken: string;
  recaptchaToken?: string | null;
}

export interface PasskeyOtpValidateState {
  loading: boolean;
  isValidated: boolean;
  error: any | null;
}

const initialState: PasskeyOtpValidateState = {
  loading: false,
  isValidated: false,
  error: null,
};

const passkeyOtpValidateSlice = createSlice({
  name: 'passkeyOtpValidate',
  initialState,
  reducers: {
    passkeyOtpValidateRequest(
      state,
      _action: PayloadAction<PasskeyOtpValidatePayload>
    ) {
      state.loading = true;
      state.isValidated = false;
      state.error = null;
    },
    passkeyOtpValidateSuccess(state) {
      state.loading = false;
      state.isValidated = true;
      state.error = null;
    },
    passkeyOtpValidateFailure(state, action: PayloadAction<any>) {
      state.loading = false;
      state.isValidated = false;
      state.error = action.payload;
    },
    resetPasskeyOtpValidate() {
      return initialState;
    },
  },
});

export const {
  passkeyOtpValidateRequest,
  passkeyOtpValidateSuccess,
  passkeyOtpValidateFailure,
  resetPasskeyOtpValidate,
} = passkeyOtpValidateSlice.actions;

export default passkeyOtpValidateSlice.reducer;
